import React from 'react';
import Grid from '../layout/grid';

export default props => {
	return (
		<Grid cols={props.cols} style={{ minWidth: props.minWidth, maxWidth: props.maxWidth }}>
			<div className='form-group'>
				<label htmlFor={props.name} style={{ fontWeight: 'normal' }}>{props.label}</label>
				<input {...props.input}
					className='form-control'
					maskChar={' '}
					placeholder={props.placeholder}
					readOnly={props.readOnly} type={'date'}
					value={(props.value || '').split('/').join('-').split('T')[0]}
					onChange={data => props.onChange(data.target.value || null)} />
			</div>
		</Grid>
	);
}
